var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25.0001C50 11.193 38.8071 0.00012207 25 0.00012207C11.1929 0.00012207 0 11.193 0 25.0001C0 38.8072 11.1929 50.0001 25 50.0001C38.8071 50.0001 50 38.8072 50 25.0001Z",
    fill: "#FEBF21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25.0001C38 17.8204 32.1797 12.0001 25 12.0001C17.8203 12.0001 12 17.8204 12 25.0001C12 32.1798 17.8203 38.0001 25 38.0001C32.1797 38.0001 38 32.1798 38 25.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.166 18.914L25.806 27.536H23.196L22.836 18.914H26.166ZM24.546 32.144C24.006 32.144 23.562 31.988 23.214 31.676C22.878 31.352 22.71 30.956 22.71 30.488C22.71 30.008 22.878 29.606 23.214 29.282C23.562 28.958 24.006 28.796 24.546 28.796C25.074 28.796 25.506 28.958 25.842 29.282C26.19 29.606 26.364 30.008 26.364 30.488C26.364 30.956 26.19 31.352 25.842 31.676C25.506 31.988 25.074 32.144 24.546 32.144Z",
    fill: "#FDBF22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarningIcon);
export default __webpack_public_path__ + "static/media/toast-warning-icon.4b630952f55118bbbf9a016e9879b9e2.svg";
export { ForwardRef as ReactComponent };